export default {
  meta: {
    title: 'location-组件展示'
  }
};
